import { useState, useEffect } from "react";
import { Form, Spin, Tabs, Row, Col, Input, Button, Select, DatePicker } from "antd";

import dayjs from 'dayjs';

import { NumericFormat, PatternFormat } from "react-number-format";

import { UserOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { apiEntidade } from "../../../services/api";
import { isStateValid, onlyNumbers, pushToBase, resetColor } from "../../../utils/utilsFunctions";

import type { ICtrlDoc, IDocumento, IEfpc, IFundamentacaoLegal, IPessoaJuridica, ISelectList } from "../../../components/Interfaces";

import { errorMessage, successMessage, mostrarInfo, mostrarInfoDetail, infoMessage } from "../../../messages/messages";
import type { IErroApi } from "../../../services/api";

import { useLocation, useParams } from "react-router";
import CadInfoBotoes from "../../../components/CadInfoBotoes";
import FormModalDocumento from "../../../components/FormModalDocumento";
import { carregaListaDocumento, carregaListaFundamentacaoLegal } from "../../PessoaJuridica/services";
import { maskCnpj, maskNuMatricula } from "../../../utils/maskFunctions";
import TextArea from "antd/es/input/TextArea";
import ModalPessoaJuridica from "../../PessoaJuridica/Componentes/ModalPessoaJuridica";


const Manter = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { tipo } = useParams();

  const [form] = Form.useForm();

  const [efpcRecebida, setEfpcRecebida] = useState<IEfpc>(); // REGISTRA OS DADOS ORIGINAIS RECEBIDOS NA ENTRADA DA PÁGINA
  const [dadosEfpc, setDadosEfpc] = useState<IEfpc>();
  const [pessoaJuridicaEfpc, setPessoaJuridicaEfpc] = useState<IPessoaJuridica>();

  const [documentos, setDocumentos] = useState<IDocumento[]>([]);
  const [efpcDocumento, setEfpcDocumento] = useState<IDocumento[]>([]);
  const [efpcDocumentoOutros, setEfpcDocumentoOutros] = useState<IDocumento[]>([]);
  const [efpcDocumentoAnalise, setEfpcDocumentoAnalise] = useState<IDocumento[]>([]);

  const [ctrlDocsEfpcDocumento, setCtrlDocsEfpcDocumento] = useState<ICtrlDoc[]>([]);
  const [ctrlDocsEfpcDocumentoOutros, setCtrlDocsEfpcDocumentoOutros] = useState<ICtrlDoc[]>([]);
  const [ctrlDocsEfpcDocumentoAnalise, setCtrlDocsEfpcDocumentoAnalise] = useState<ICtrlDoc[]>([]);

  const [manter, setManter] = useState(1); // 1 : Inserir / 2 : Consultar / 3 : Editar; / -2 : Estado temporário de cancelamento de edição.

  const [listFundamentacaoLegal, setListFundamentacaoLegal] = useState<ISelectList[]>([]);
  const [fundamentacaoLegal, setFundamentacaoLegal] = useState(-1);
  const [listDocumentosEstatuto, setListDocumentosEstatuto] = useState<ISelectList[]>([]);
  const [listDocumentosOutrosEfpc, setListDocumentosOutrosEfpc] = useState<ISelectList[]>([]);
  const [listDocumentosAnalise, setListDocumentosAnalise] = useState<ISelectList[]>([]);

  const [erroApi, setErroApi] = useState<IErroApi>()
  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")

  const [mostrarDetalhesPessoaJuridica, setMostrarDetalhesPessoaJuridica] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)

    setLoading(true);
    //console.log(state);
    const carregaDadosIniciais = async () => {
      if (listFundamentacaoLegal.length === 0) carregaListaFundamentacaoLegalOpcoes();
      if (listDocumentosEstatuto.length === 0) carregaListaDocumentosEstatutoOpcoes();
      if (listDocumentosOutrosEfpc.length === 0) carregaListaDocumentosOutrosEfpcOpcoes();
      if (listDocumentosAnalise.length === 0) carregaListaDocumentosAnaliseOpcoes();
    }
    carregaDadosIniciais();
    setLoading(false);

    if (isStateValid(state)) {
      if (!tipo) {
        validaEfpcRecebidoViaStatus(state.data);
      } else {
        errorMessage("Erro sistémico. Este modo não deveria receber dados via 'state'.");
        pushToBase(navigate);
      }
      setManter(state.manter);
    }

  }, []);

  useEffect(() => {
    if (listFundamentacaoLegal && listFundamentacaoLegal.length > 0 && fundamentacaoLegal >= 0) {
      form.setFieldsValue({
        nmFundamentacaoLegal: listFundamentacaoLegal.find(l => l.value === fundamentacaoLegal)?.label
      });

    }
  }, [fundamentacaoLegal, listFundamentacaoLegal]);

  useEffect(() => {
    if (manter === -2) { // edição cancelada
      setDadosEfpc(undefined); // LIMPA OS DADOS
      setManter(2); // MUDA PARA O ESTADO DETALHAR
    }

    if (manter === 2) {
      if (!dadosEfpc) setDadosEfpc(efpcRecebida); // RETORNA COM OS DADOS ORIGINAIS RECEVIDOS VIA STATUS OU VIA RESPONSE
    }

    if (manter === 3) {
      validarVersionar()
    }
  }, [manter]);

  useEffect(() => {
    if (dadosEfpc) {
      setEfpcRecebida(dadosEfpc);
      setFundamentacaoLegal(dadosEfpc.fundamentacaoLegal);
      setPessoaJuridicaEfpc(dadosEfpc.pessoaJuridicaEfpc);
      setDocumentos(dadosEfpc.documentos);

      form.setFieldsValue({
        sigla: dadosEfpc.sigla,
        numero: maskNuMatricula(dadosEfpc.numero),
        tipo: dadosEfpc.tipo,
        nmFundamentacaoLegal: listFundamentacaoLegal.find(l => l.value === dadosEfpc.fundamentacaoLegal)?.label,
        quantidadeDiretores: dadosEfpc.quantidadeDiretores,
        nmEsi: dadosEfpc.nomeEnquadramento,
        quantidadeConselheiroFiscal: dadosEfpc.quantidadeConselheiroFiscal,
        quantidadeConselhoDeliberativo: dadosEfpc.quantidadeConselhoDeliberativo,
        nmSituacao: dadosEfpc.situacaoAtualEfpc + (dadosEfpc.situacaoAtualSecundariaEfpc ? " - " + dadosEfpc.situacaoAtualSecundariaEfpc : ""),
        dataSituacao: dadosEfpc.dataVigencia ? dayjs(dadosEfpc.dataVigencia).format('DD/MM/YYYY') : undefined,
        dataAprovacaoAutorizacao: dadosEfpc.dataAutorizacao ? dayjs(dadosEfpc.dataAutorizacao).format('DD/MM/YYYY') : undefined,
        dataInicioFuncionamento: dadosEfpc.dataInicioFuncionamento ? dayjs(dadosEfpc.dataInicioFuncionamento) : undefined,
      });
    }
  }, [dadosEfpc]);

  useEffect(() => {
    if (pessoaJuridicaEfpc) {
      form.setFieldsValue({
        efpcNumeroEfpcCnpj: pessoaJuridicaEfpc.tipoIdentificador === 1 ? pessoaJuridicaEfpc.numero : undefined,
        efpcNumeroEfpcProcesso: pessoaJuridicaEfpc.tipoIdentificador === 3 ? pessoaJuridicaEfpc.numero : undefined,
        efpcNumeroProcesso: pessoaJuridicaEfpc.numeroProcesso,
        efpcRazaoSocial: pessoaJuridicaEfpc.razaoSocial
      });
    }
  }, [pessoaJuridicaEfpc]);

  useEffect(() => {
    if (documentos) {
      setEfpcDocumento(documentos.filter(doc => (BigInt(doc.bitwise || 0) & 1126999418470400n) === 1126999418470400n)); // DOCUMENTOS DA ENTIDADE
      setEfpcDocumentoOutros(documentos.filter(doc => (BigInt(doc.bitwise || 0) & 2252899325313024n) === 2252899325313024n)); // DOCUMENTOS DA ENTIDADE OUTROS
      setEfpcDocumentoAnalise(documentos.filter(doc => (BigInt(doc.bitwise || 0) & 4504699138998272n) === 4504699138998272n)); // DOCUMENTOS DA ENTIDADE ANÁLISE
    }
  }, [documentos]);


  function validaEfpcRecebidoViaStatus(efpc: any) {
    if (!efpc || efpc.serie <= 0) {
      errorMessage("Entidade não identificada");
      pushToBase(navigate);
    } else {
      setDadosEfpc(efpc)
    }
  }

  useEffect(() => {
    if (erroApi && estadoErroApi > 0) {
      //console.log(estadoErroApi);
      //console.log(erroApi);
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi, estadoErroApi])

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const validarEfpc = () => {
    if (!pessoaJuridicaEfpc || !pessoaJuridicaEfpc.numero || pessoaJuridicaEfpc.numero === "") {
      errorMessage("Não foi possível identificar a Pessoa Jurídica para vincular à Entidade.");
      return;
    }

    // if (!currentForm.efpcNumeroProcesso || currentForm.efpcNumeroProcesso === "") {
    //   errorMessage("Número do processo da EFPC não pode ficar vazio.");
    //   return;
    // }

    form
      .validateFields()
      .then(() => {
        sendForm();
      })
      .catch((_error) => {
        errorMessage("Campo obrigatório não preechido");
      });

  };

  const sendForm = async () => {
    const currentForm = form.getFieldsValue();

    setTipLoading("Salvando dados ...");
    setLoading(true);

    const json: IEfpc =
    {
      numero: dadosEfpc?.numero || "",
      serie: dadosEfpc?.serie,
      sigla: currentForm.sigla,
      quantidadeDiretores: currentForm.quantidadeDiretores,
      quantidadeConselheiroFiscal: currentForm.quantidadeConselheiroFiscal,
      quantidadeConselhoDeliberativo: currentForm.quantidadeConselhoDeliberativo,
      fundamentacaoLegal: fundamentacaoLegal,
      tipo: 1,
      dataVigencia: dayjs().format("YYYY-MM-DD"),
      dataInicioFuncionamento: currentForm.dataInicioFuncionamento ? dayjs(currentForm.dataInicioFuncionamento).format("YYYY-MM-DD") : "",
      observacoes: currentForm.observacoes,
      justificativaAtualizacao: currentForm.justificativaVersionamento,
      numeroPessoaJuridica: currentForm.cnpjNumero && currentForm.cnpjNumero !== "" ? onlyNumbers(currentForm.cnpjNumero) : pessoaJuridicaEfpc ? pessoaJuridicaEfpc.numero : "",
      documentos: [
        ...(efpcDocumento ?? []),
        ...(efpcDocumentoOutros ?? []),
        ...(efpcDocumentoAnalise ?? [])
      ].map((e: IDocumento) => ({ ...e })),
    }

    let query = `/versionar/${dadosEfpc?.serie}/serie`;

    await apiEntidade.post(query, json).then((response) => {
      setLoading(false);

      successMessage(
        `Entidade ${form?.getFieldValue("sigla")} (${maskNuMatricula(form.getFieldValue("numero"))}) versionada com Sucesso`
      );
      setManter(2);
      setDadosEfpc(response.data);
    })
      .catch(error => {
        let data: IErroApi = error.response.data;
        let msgErro = data.mensagem ? data.mensagem : error.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(error.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (error.response.status < 500) {
          setErroApi(data);
        } else {
          if (error.response.status === 503)
            errorMessage("Servidor remoto não disponível");
          else
            errorMessage(msgErro);
        }
        setLoading(false);
      });
  }

  const onFinishFailed = () => {
    errorMessage("Campo obrigatório não preechido");
  };

  const resetForm = () => {
    setLoading(true);
    form.getFieldsValue();
    form.setFieldsValue({
      idEfpc: undefined,
      idPessoaJuridica: undefined,
      dtInicioAtuacao: undefined,
      dtFimAtuacao: undefined,
      campoServidorPublico: undefined,
      nuCnpj: undefined,
      razaoSocial: undefined,
      matriculaSiape: undefined,
      nmCargoOrigem: undefined,
    });
    setLoading(false);
    window.scrollTo(0, 0)
  };

  const validarVersionar = () => {
    if (pessoaJuridicaEfpc?.tipoIdentificador === 3) { // Número de processo.
      infoMessage("Essa entidade só pode ser versionada se houver a alteração do Número de Processo para CNPJ como o tipo de identificador da Pessoa Jurídica ");
    }
    setManter(3);
  };

  const carregaListaDocumentosEstatutoOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("1126999420597250").then((response) => {
      setCtrlDocsEfpcDocumento(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
      setListDocumentosEstatuto(listaLocal);
    });
  }

  const carregaListaDocumentosOutrosEfpcOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("2252899327430658").then((response) => {
      setCtrlDocsEfpcDocumentoOutros(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
    });
    setListDocumentosOutrosEfpc(listaLocal);
  }

  const carregaListaDocumentosAnaliseOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("4504699141109761").then((response) => {
      setCtrlDocsEfpcDocumentoAnalise(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
    });
    setListDocumentosAnalise(listaLocal);
  }


  const carregaListaFundamentacaoLegalOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaFundamentacaoLegal().then((response) => {
      response.data.forEach((p: IFundamentacaoLegal) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListFundamentacaoLegal(listaLocal);
  }

  const handleFundamentacaoLegal = async (fundamentacaoLegal: any) => {
    form.setFieldsValue({
      nmFundamentacaoLegal: fundamentacaoLegal.label,
    });
    setFundamentacaoLegal(fundamentacaoLegal.value);
  };

  return (
    <>
      {/* <Prompt
        when={idEfpc !== undefined && idEfpc !== 0}
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}

      <Spin spinning={loading} tip={tipLoading}>

        <Form layout='vertical' style={{ padding: 24 }} form={form} >
          <div className="main-content pl-sm-3 mt-4">
            <h1>{
              (() => {
                switch (manter) {
                  case 1:
                    return "Cadastrar Entidade"
                  case 2:
                    return "Detalhar Entidade"
                  case 3:
                    return "Versionar Entidade"
                  default:
                    return null
                }
              })()}
            </h1>
          </div>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações Básicas da Entidade</h2>
          </div>

          <Row>
            <Col xs={24} xl={5} hidden={pessoaJuridicaEfpc?.tipoIdentificador === 3}>
              <Form.Item
                label="CNPJ da Entidade"
                name="efpcNumeroEfpcCnpj">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="##.###.###/####-##"
                />
              </Form.Item>
            </Col>


            <Col xs={24} xl={7} hidden={pessoaJuridicaEfpc?.tipoIdentificador !== 3}>
              <Form.Item
                label="Identificador Provisório (Processo)"
                name="efpcNumeroEfpcProcesso">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="#####.######/####-##"
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={7} hidden={pessoaJuridicaEfpc?.tipoIdentificador !== 3}>
              <Form.Item
                label='CNPJ'
                name='cnpjNumero'>
                <Input maxLength={18}
                  disabled={manter === 2 ? true : false}
                  onChange={(e) =>
                    form.setFieldsValue({
                      cnpjNumero: maskCnpj(e.target.value),
                    })
                  }
                />
              </Form.Item>
            </Col>


            <Col xs={24} xl={5} hidden={pessoaJuridicaEfpc?.tipoIdentificador === 3}>
              <Form.Item
                label="Número do processo"
                name="efpcNumeroProcesso">
                <PatternFormat
                  customInput={Input}
                  format="#####.######/####-##"
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={10}>
              <Form.Item label="Razão Social"
                name="efpcRazaoSocial">
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} xl={4} >
              <Form.Item style={{ alignItems: 'center' }}
                label={"Detalhar Cadastro de Pessoa Jurídica"}
              >
                <Button
                  shape='round'
                  onClick={() => {
                    setMostrarDetalhesPessoaJuridica(!mostrarDetalhesPessoaJuridica);
                  }}
                  type='primary'
                  icon={<UserOutlined />}
                />
              </Form.Item>
            </Col>
          </Row>

          <ModalPessoaJuridica
            pessoaJuridicaEfpc={pessoaJuridicaEfpc}
            modalPessoaJuridicaSucessoAberto={mostrarDetalhesPessoaJuridica}
            setModalPessoaJuridicaSucessoAberto={setMostrarDetalhesPessoaJuridica}
          />

          <div className="main-content pl-sm-3 mt-4">
            <h2>Perfil da Entidade</h2>
          </div>

          <Row>
            <Col xs={24} md={12} xl={4}>
              <Form.Item
                label="Código"
                name="numero"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={4}>
              <Form.Item
                label="Sigla"
                name="sigla"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={4}>
              <Form.Item
                label="Tipo"
                name="tipo"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={5}>
              <Form.Item
                label="Fundamentação Legal"
                name="nmFundamentacaoLegal"
                rules={[
                  {
                    required: true,
                    message: "Fundamentação Legal obrigatório não preenchido",
                  },
                ]}
              >
                <Select
                  disabled={manter === 2 ? true : false}
                  showSearch filterOption optionFilterProp='children'
                  placeholder='SELECIONE UMA FUNDAMENTAÇÃO LEGAL'
                  options={listFundamentacaoLegal}
                  onChange={(_, index) => {
                    handleFundamentacaoLegal(index);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={7}>
              <Form.Item
                label="Tipo de Convenente Predominante"
                name="tipoConvenente"
              >
                <Input placeholder="CAMPO CALCULADO" disabled />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12} xl={8}>
              <Form.Item
                label="ESI"
                name="nmEsi"
              >
                <Input placeholder="SEM INFORMAÇÃO" disabled />
              </Form.Item>
            </Col>

            <Col xs={24} xl={5}>
              <Form.Item
                label="Qtd. Máx Diretores Executivos"
                name="quantidadeDiretores"
                rules={[
                  {
                    required: true,
                    message:
                      "Qtd. Máx de diretores Executivos obrigatório não preenchido",
                  },
                ]}
              >
                <NumericFormat
                  disabled={manter === 2 ? true : false}
                  customInput={Input}
                  placeholder="Digitar Qtd. Máx de diretores Executivos"
                  allowNegative={false}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={5}>
              <Form.Item
                label="Qtd. Máx Conselheiros Fiscais"
                name="quantidadeConselheiroFiscal"
                rules={[
                  {
                    required: true,
                    message:
                      "Qtd. Máx de Conselheiros Fiscais obrigatório não preenchido",
                  },
                ]}
              >
                <NumericFormat
                  disabled={manter === 2 ? true : false}
                  customInput={Input}
                  placeholder="Digitar Qtd. Máx de Conselheiros Fiscais"
                  allowNegative={false}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Qtd. Máx Conselheiros Deliberativos"
                name="quantidadeConselhoDeliberativo"
                rules={[
                  {
                    required: true,
                    message:
                      "Qtd. Máx de Conselheiros Deliberativos obrigatório não preenchido",
                  },
                ]}
              >
                <NumericFormat
                  disabled={manter === 2 ? true : false}
                  customInput={Input}
                  placeholder="Digitar Qtd. Máx de Conselheiros Deliberativos"
                  allowNegative={false}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12} xl={12}>
              <Form.Item
                label="Situação"
                name="nmSituacao">
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data da Situação"
                name="dataSituacao">
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Qualificação Quanto ao Número de Planos"
                name="qnp"
              >
                <Input placeholder="CAMPO CALCULADO" disabled />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data da Autorização"
                name="dataAprovacaoAutorizacao"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data de Encerramento"
                name="dataEncerramento"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data de início de Funcionamento"
                name="dataInicioFuncionamento">
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabled={manter === 2 ? true : dadosEfpc && dadosEfpc.dataInicioFuncionamento ? true : false}
                />
              </Form.Item>
            </Col>

          </Row>

          <Row style={{ display: mostrarDetalhesPessoaJuridica ? 'inline' : 'none' }} >
            {/* <>
              <PessoaJuridicaDadosComplementares
                form={form}
                idPessoaFisica={state.idPessoaFisica}
                mostrarDetalhesPessoaFisica={mostrarDetalhesPessoaJuridica}
              />
            </> */}
          </Row>

          <Row>
            <Col xs={24} xl={24} hidden={manter !== 3}>
              <Form.Item
                label="Justificativa do Versionamento"
                name="justificativaVersionamento"
                rules={[
                  {
                    required: true,
                    message: "Preencha a justificativa do versionamento",
                  },
                ]}
              >
                <TextArea
                  onChange={(e) =>
                    form.setFieldsValue({
                      justificativaVersionamento: e.target.value.toUpperCase(),
                    })
                  }
                />
              </Form.Item>
            </Col>

          </Row>

        </Form>

        <Tabs>
          <Tabs.TabPane tab="Estatuto" key="item-1">
            <>
              <FormModalDocumento
                ctrlDoc={ctrlDocsEfpcDocumento}
                objetoDocumento={efpcDocumento}
                setObjetoDocumento={setEfpcDocumento}
                listaDocumentos={listDocumentosEstatuto}
                manter={manter}
              />
            </>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Outros Documentos da Entidade" key="item-2">
            <>
              <FormModalDocumento
                ctrlDoc={ctrlDocsEfpcDocumentoOutros}
                objetoDocumento={efpcDocumentoOutros}
                setObjetoDocumento={setEfpcDocumentoOutros}
                listaDocumentos={listDocumentosOutrosEfpc}
                manter={manter}
              />
            </>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Documentação de Análise/Autorização" key="item-3">
            <>
              <FormModalDocumento
                ctrlDoc={ctrlDocsEfpcDocumentoAnalise}
                objetoDocumento={efpcDocumentoAnalise}
                setObjetoDocumento={setEfpcDocumentoAnalise}
                listaDocumentos={listDocumentosAnalise}
                manter={manter}
              />
            </>
          </Tabs.TabPane>

        </Tabs>
        <Form layout='vertical' style={{ padding: 24 }} onFinish={validarEfpc} onFinishFailed={onFinishFailed} scrollToFirstError form={form} >

          <CadInfoBotoes
            resetForm={resetForm}
            detalhar={false}
            form={form}
            resetColor={resetColor}
            manter={manter}
            setManter={setManter}
            msgConfirmacao={`Entidade: ${dadosEfpc?.sigla}`}
            rotaConsultar={"/" + import.meta.env.VITE_APP_BASE + "/efpc-consultar"}
          />

        </Form>
      </Spin>

    </>
  );
};

export default Manter;